export default "__VITE_ASSET__BmYQ1AfA__"